import type {ReactAction} from '@netx/core/bootstrap';
import {faPlus} from '@fortawesome/pro-solid-svg-icons';
import {CART_CURRENT_ACTION_LABELS} from '@netx/core-cart-current/locales';
import {CATEGORY_EVENT, OrganizeAssetsAction} from '@netx/core-category-next';
import {canOrganizeAsset} from '../enablers';
import {type IAsset} from '../schema';

/**
 * Add asset to folder
 * @param params
 * @returns Action
 */
export const assetActionCategorizeAdd = (
	asset: IAsset,
	params: Partial<ReactAction> = {},
): ReactAction => ({
	name: 'asset-categorize-add',
	cb: () =>
		dispatcher.trigger(CATEGORY_EVENT.SHOW_ORGANIZE_ASSETS, {
			asset: asset,
			action: OrganizeAssetsAction.ADD,
		}),
	enableTest: () => canOrganizeAsset(asset),
	icon: faPlus,
	get label() {
		return CART_CURRENT_ACTION_LABELS.CATEGORIZE_ADD;
	},
	...params,
});

export default assetActionCategorizeAdd;
